import {Controller} from '@hotwired/stimulus';

/**
 * Section repliable de fin de formulaire (composant Twig `FormAccordion`, accordion.md) : un lien de la page vers
 * un champ de la section fermée, comme celui du récapitulatif d'erreurs, ouvre d'abord la section puis place le
 * focus dans le champ (`form-accordion#reveal` sur `click@document`, posé par le composant). L'ouverture et la
 * fermeture passent par le balisage Bootstrap (`data-bs-toggle="collapse"` sur l'en-tête).
 */
export default class extends Controller {
  static targets = ['toggle', 'content'];

  reveal(event) {
    const link = event.target.closest('a[href^="#"]');

    if (!link || link.hash.length < 2 || this.toggleTarget.getAttribute('aria-expanded') === 'true') {
      return;
    }

    const field = document.getElementById(decodeURIComponent(link.hash.slice(1)));

    if (!field || !this.contentTarget.contains(field)) {
      return;
    }

    event.preventDefault();
    // un champ désactivé (adresse de la page verrouillée) ou une cible qui n'est pas un champ ne prend pas le focus
    this.contentTarget.addEventListener('shown.bs.collapse', () => {
      field.scrollIntoView({block: field.matches('input, select, textarea') ? 'center' : 'start'});
      field.focus({preventScroll: true});
    }, {once: true});
    this.toggleTarget.click();
  }
}
